import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useSessionUuidAsync } from '#src/app/shared/hooks/session';
import type { ShareLink } from '#src/app/shared/hooks/share';
import { isLoaded } from '#src/app/shared/utils/async';

import { getPetitionMobileNativeShareLink } from './api';

const QUERY_KEY = 'petition-mobile-native-share-link';

type PetitionMobileNativeShareLinkResult = {
	link: ShareLink | null;
	isLoading: boolean;
};

export function usePetitionMobileNativeShareLink(): PetitionMobileNativeShareLinkResult {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const utilityContext = useUtilityContext();
	// `useMobileNativeShare` is now called unconditionally during SSR (see MobileSignButton),
	// unlike its original client-only call site (NativeShareMobile, gated behind <ClientRender>) — the
	// sync useSessionUuid() throws in that env for guests, so this must use the Async variant.
	const sessionUuidState = useSessionUuidAsync();
	const sessionUuid = isLoaded(sessionUuidState) ? sessionUuidState.value : undefined;

	const { data = null, isLoading } = useQuery({
		queryKey: [QUERY_KEY, { id, sessionUuid }],
		queryFn: async () => getPetitionMobileNativeShareLink({ id, utilityContext }),
		staleTime: Infinity,
	});

	return { link: data, isLoading };
}
